import moment from 'moment';
import 'moment/dist/locale/fr.js';

moment.locale('fr');

class Commons {
  static time(time, dateFormat = 'DD MMMM YYYY') {
    if (/^\d+$/.test(time)) time = parseInt(`${time}`);
    return moment(new Date(time)).format(dateFormat);
  }

  static idle(fn) {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(fn, { timeout: 1000 });
    } else {
      setTimeout(fn, 0);
    }
  }

  static formatNumber(
    value,
    { locale = 'fr-FR', decimals = 0, compact = false, suffix = '' } = {}
  ) {
    if (value == null || isNaN(value)) return '—';

    const formatter = new Intl.NumberFormat(locale, {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
      notation: compact ? 'compact' : 'standard',
      compactDisplay: 'short'
    });

    return formatter.format(value) + suffix;
  }

  static isCapacitor() {
    return /capacitor/i.test(window.location.href);
  }

  static getDeviceToken() {
    return new Promise((resolve) => {
      if (!Commons.isCapacitor()) {
        resolve(null);
        return;
      }

      const requestId = Commons.generateUUID();
      const responseHandler = (event) => {
        if (
          event.data?.type === 'DEVICE_TOKEN_RESPONSE' &&
          event.data.requestId === requestId
        ) {
          window.removeEventListener('message', responseHandler);
          resolve(event.data.token);
        }
      };

      window.addEventListener('message', responseHandler);

      try {
        window.parent.postMessage(
          {
            type: 'REQUEST_DEVICE_TOKEN',
            requestId: requestId
          },
          '*'
        );
      } catch (error) {
        window.removeEventListener('message', responseHandler);
        console.log('🚀 ~ Commons ~ getDeviceToken ~ error:', error);
        resolve(null);
      }

      // Timeout après 3 secondes
      setTimeout(() => {
        window.removeEventListener('message', responseHandler);
        resolve(null);
      }, 3000);
    });
  }

  static copyToClipboard(text, onSuccess = () => {}, onFailed = (err) => {}) {
    // utiliser capacitor si dispo, sinon l'api native
    if (Commons.isCapacitor()) {
      Commons.copyViaCapacitor(text, onSuccess, onFailed);
    } else {
      Commons.copyViaNative(text, onSuccess, onFailed);
    }
  }

  // méthode via capacitor (postMessage)
  static copyViaCapacitor(text, onSuccess, onFailed) {
    const requestId = Commons.generateUUID();

    const responseHandler = (event) => {
      if (
        event.data?.type === 'COPY_RESPONSE' &&
        event.data.requestId === requestId
      ) {
        window.removeEventListener('message', responseHandler);

        if (event.data.success) {
          onSuccess && onSuccess();
        } else {
          onFailed &&
            onFailed(new Error(event.data.error || 'erreur de copie'));
        }
      }
    };

    window.addEventListener('message', responseHandler);

    try {
      window.parent.postMessage(
        {
          type: 'COPY_REQUEST',
          text: text,
          requestId: requestId
        },
        '*'
      );
    } catch (error) {
      window.removeEventListener('message', responseHandler);
      console.log('🚀 ~ Commons ~ copyViaCapacitor ~ error:', error);
      onFailed && onFailed(error);
    }

    // timeout de 5 secondes
    setTimeout(() => {
      window.removeEventListener('message', responseHandler);
      onFailed && onFailed(new Error('timeout de copie'));
    }, 5000);
  }

  // méthode native (clipboard api)
  static copyViaNative(text, onSuccess, onFailed) {
    try {
      const type = 'text/plain';
      const blob = new Blob([text], { type });
      const data = [new ClipboardItem({ [type]: blob })];
      navigator.clipboard.write(data);
      onSuccess && onSuccess();
    } catch (error) {
      console.log('🚀 ~ Commons ~ copyViaNative ~ error:', error);
      onFailed && onFailed(error);
    }
  }

  static setThemeColor(color = '#ffffff') {
    try {
      const themeColorMetaTag = document.querySelector('[name="theme-color"]');
      themeColorMetaTag.setAttribute('content', color);
      if (themeColorMetaTag.getAttribute('content') !== color)
        Commons.setThemeColor(color);
    } catch (error) {
      console.log('🚀 ~ Commons ~ setThemeColor ~ error:', error);
    }
  }

  static generateUUID() {
    const buf = new Uint8Array(16);
    crypto.getRandomValues(buf);

    // Version 4
    buf[6] = (buf[6] & 0x0f) | 0x40;
    buf[8] = (buf[8] & 0x3f) | 0x80;

    const hex = [...buf].map((v) => v.toString(16).padStart(2, '0')).join('');

    return (
      hex.slice(0, 8) +
      '-' +
      hex.slice(8, 12) +
      '-' +
      hex.slice(12, 16) +
      '-' +
      hex.slice(16, 20) +
      '-' +
      hex.slice(20)
    );
  }
}

export default Commons;
